import React, { useContext, useState, useEffect } from 'react';
import { StudentGradesContext } from '../context/StudentGradesContext'; // Importing the context

function LongAnswerGradeBox({ questionID, evaluationID, username }) {
  const { studentGradesState, handleGradeChange } = useContext(StudentGradesContext);
  const [grade, setGrade] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  // Sync grade from context, but never overwrite while the TA is actively editing.
  useEffect(() => {
  if (isFocused) return;
  if (!studentGradesState || !studentGradesState[username]) {
    return;
  }

  const userGrades = studentGradesState[username];
  const currentGrade = userGrades.find((g) => g.questionID === questionID);

  if (currentGrade) {
    setGrade(currentGrade.individualGradingData);
  } else {
    setGrade('');
  }
}, [studentGradesState, questionID, username, isFocused]);


  const handleChange = (event) => {
    const value = event.target.value;
    const regex = /^(10|10.0|[0-9]|([0-9]\.\d?))$/;

    if (value === '' || regex.test(value)) {
      const numericValue = parseFloat(value);
      if (numericValue <= 10 || value === '') {
        setGrade(value);
        handleGradeChange(username, questionID, 'questionGrade', value, '', evaluationID);
      }
    }
  };

  return (
    <div>
      <label>
        Question grade:
        <input
          type="text"
          value={grade || ''}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />
      </label>
    </div>
  );
}

export default LongAnswerGradeBox;
